import React from 'react';
import { useAlert } from 'react-alert';

export const ReferFriend = props => {
    const [email, setEmail] = React.useState('');
    const [name, setName] = React.useState('');
    const [disableSubmit, setDisableSubmit] = React.useState(true);

    React.useEffect(() =>{
        if('parentIFrame' in window){
            window.parentIFrame.scrollTo(0, 0);
        }
    }, []);

    const submitEmail = (ev) =>{
        ev.preventDefault();
        var body = {
            email: email,
            name: name
        };
        // console.log("You have submitted: " + email);
        fetch(localStorage.getItem('server') + 'refer', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                token: sessionStorage.getItem('token'),
                memberNumber: sessionStorage.getItem('memberNumber')
            }
        })
        .then(function(response){
            return response.json()
        })
        .then(function(data){
            if(data.status === 401){
                // console.log("Invalid Token - Redirecting to login");
                // props.history.push("");
                alert.show(
                    <span ref={sessionRef}>
                        Your session has expired. Please login to continue.
                    </span>
                    , {
                        title: "Session Expired"
                });
            } else if(data.status === 429){
                alert.show(
                    <span ref={sessionRef}>
                        Too many requests. Please try again later.
                    </span>
                    , {
                        title: "Uh Oh..."
                });
            } else if(data.status === 429){
                alert.show(
                    <span ref={sessionRef}>
                        Too many requests. Please try again later.
                    </span>
                    , {
                        title: "Uh Oh..."
                });
            } else {
                if(data.success){
                    alert.show(<span className="text-justify">The referral email has been sent. Keep an eye on your profile for the voucher when your friend completes their signup process!<br/><br/><button className="btn btn-primary center-btn style-btn" onClick={confirmDialog}>Finish</button></span>, {
                        title: 'Thank you for referring your friend',
                        hideClose: true
                    });
                } else {
                    alert.show('But your friend has already received a referral code', {
                        title: 'Thank you for referring your friend'
                    });
                }
            }
        });
    }

    const confirmDialog = () =>{
        document.querySelectorAll('.MuiDialog-root').forEach(e=> e.remove());
        redirectHome();
    }

    const handleEmailChange = (ev) =>{
        setEmail(ev.currentTarget.value);
        if(ev.currentTarget.value && name){
            setDisableSubmit(false);
        } else {
            setDisableSubmit(true);
        }
    }

    const handleNameChange = (ev) =>{
        setName(ev.currentTarget.value);
        if(ev.currentTarget.value && email){
            setDisableSubmit(false);
        } else {
            setDisableSubmit(true);
        }
    }

    const redirectHome = () =>{
        props.history.push('/home')
    }

    const sessionRef = (node)=>{
        if(node === null){
            window.location.replace(window.location.origin);
        }
    }

    const alert = useAlert();

    return(
        <div className="container">
            <div className="mini-form">
                <h2 className="text-center"><strong>Refer a Friend</strong></h2>
                <p className="text-justify">Refer a friend and you will receive a free main meal with your main meal purchase if your friend joins! Simply enter their email address to send them a referral link!</p>
            
                <form>
                    <input onChange={handleNameChange} className="form-control" placeholder="Name" />
                    <input onChange={handleEmailChange} className="form-control" type="text" placeholder="Email" />
                    <button className="form-btn btn btn-primary" onClick={submitEmail} disabled={disableSubmit}>Submit</button>
                </form>
                <button onClick={redirectHome} className="form-btn btn btn-primary">Back</button>
            </div>
        </div>
    )
}